import React, { useState, useEffect, useContext } from "react";
import styled from "styled-components";
import { Modal } from "react-responsive-modal";
import "../../styles/CustomModal.css";
import "react-responsive-modal/styles.css";

type Props = {
  isVisible: boolean;
  setVisible: (bVisible: boolean) => void;
};

const minuteList: any = [];
for (let i = 3; i < 19; i++) {
  minuteList.push({
    value: i > 1 ? (i * 5).toString() : "0" + (i * 5).toString(),
    label: i > 1 ? `${i * 5}분` : `0${i * 5}분`,
  });
}

const DeliverySettingModal = ({ isVisible, setVisible }: Props) => {
  const [minute, setMinute] = useState<number>(15);
  const [isDirect, setIsDirect] = useState<boolean>(true);
  const [isAutoCall, setIsAutoCall] = useState<boolean>(false);

  const onCloseModal = () => {
    setVisible(false);
  };

  const onChange_minute = (event: any) => {
    setMinute(event.value);
  };

  useEffect(() => {}, []);

  const RenderCustomSelect = () => {
    const [isOpen, setIsOpen] = useState<boolean>(false);
    const [selectedOption, setSelectedOption] = useState<string>(`${minute}분`);

    const handleSelectClick = () => {
      setIsOpen(!isOpen);
    };

    const handleOptionClick = (option: any) => {
      setSelectedOption(option.label);
      onChange_minute(option);
      setIsOpen(false);
    };

    return (
      <div className="selector">
        <div className="selectHeader" onClick={handleSelectClick}>
          {selectedOption}
          <img
            src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_arrow_down_black.svg`}
            width={12}
            alt="ic"
          />
        </div>
        {isOpen && (
          <ul className="selectList">
            {minuteList.map((option: any) => (
              <li
                key={option.value}
                onClick={() => handleOptionClick(option)}
                className={`selectItem ${
                  option.label === selectedOption && "selected"
                }`}
              >
                {option.label}
              </li>
            ))}
          </ul>
        )}
      </div>
    );
  };

  return (
    <Modal
      open={isVisible}
      onClose={onCloseModal}
      center
      classNames={{
        overlay: "deliverySettingModalOverlay",
        modal: "deliverySettingModal",
      }}
      closeIcon={
        <img
          src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_close.svg`}
          alt="ic"
        />
      }
      showCloseIcon={true}
      animationDuration={150}
    >
      <Style>
        <div className="modal">
          <div className="modalHeader">
            <h3>배달 설정</h3>
          </div>
          <div className="contentWrap">
            <h3>기본 준비 완료 시간</h3>
            <p>
              주문 접수할 때, 설정한 시간을 기준으로 주문 완료 시간이 설정됩니다
            </p>
            <div className="select">
              <RenderCustomSelect />
            </div>
          </div>
          <div className="contentWrap">
            <h3>직접배달 유무 선택</h3>
            <label htmlFor="isDirect_true">
              <input
                id="isDirect_true"
                type="radio"
                checked={isDirect}
                onChange={() => setIsDirect(true)}
              />
              <div className={`checkbox ${isDirect && "active"}`}>
                {isDirect && (
                  <img
                    src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_check.svg`}
                    alt="ic"
                  />
                )}
              </div>
              사용함
            </label>
            <label htmlFor="isDirect_false">
              <input
                id="isDirect_false"
                type="radio"
                checked={!isDirect}
                onChange={() => setIsDirect(false)}
              />
              <div className={`checkbox ${!isDirect && "active"}`}>
                {!isDirect && (
                  <img
                    src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_check.svg`}
                    alt="ic"
                  />
                )}
              </div>
              사용안함
            </label>
          </div>
          <div className="contentWrap">
            <h3>배달 기사 호출 방법</h3>
            <div className="row">
              <button
                className={`selectButton left ${!isAutoCall && "active"}`}
                onClick={() => setIsAutoCall(false)}
              >
                매번 시간 선택 후 호출
              </button>
              <button
                className={`selectButton right ${isAutoCall && "active"}`}
                onClick={() => setIsAutoCall(true)}
              >
                바로 호출
              </button>
            </div>
          </div>
        </div>
      </Style>
    </Modal>
  );
};

export default DeliverySettingModal;

const Style = styled.div`
  .modal {
    height: 50vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    padding-bottom: 12%;
  }

  .modalHeader {
    padding: 4% 8%;
    width: 100%;
    border-bottom: 1px solid #f0f0f0;
    h3 {
      color: #333333;
      font-size: 20px;
      line-height: 24px;
      font-weight: 600;
      text-align: center;
    }
  }
  .contentWrap {
    padding: 0 8%;
    width: 100%;
    display: flex;
    flex-direction: column;
    text-align: left;
    gap: 10px;

    h3 {
      font-size: 18px;
      line-height: 24px;
      font-weight: 500;
      color: #333333;
    }
    p {
      font-size: 14px;
      line-height: 16px;
      color: #999999;
      font-weight: 500;
    }
  }

  input[type="radio"] {
    display: none;
  }
  label {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 16px;
    line-height: 20px;
    font-weight: 400;
    color: #333333;

    .checkbox {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 20px;
      height: 20px;
      border-radius: 3px;
      background: #ffffff;
      border: 1px solid #999999;
    }
    .checkbox.active {
      background: #5991ff;
      border: 1px solid #5991ff;
    }
  }

  .row {
    display: flex;
    align-items: center;
  }
  .selectButton {
    flex: 1;
    text-align: center;
    background: #ffffff;
    border: 1px solid #b0b0b0;
    padding: 13px;
    font-size: 14px;
    line-height: 16px;
    font-weight: 500;
    color: #b0b0b0;
  }
  .selectButton.active {
    background: #5991ff;
    border: 1px solid #5991ff;
    color: #ffffff;
  }
  .selectButton.left {
    border-radius: 5px 0 0 5px;
    border-right: none;
  }
  .selectButton.right {
    border-radius: 0 5px 5px 0;
    border-left: none;
  }

  .select {
    width: 40%;
  }
  .selector {
    position: relative;
    width: 100%;
    padding: 10px 0;
    font-size: 18px;
    line-height: 20px;
    background: #ffffff;
    border: 1px solid #999999;
    font-weight: 600;
    color: #515151;
    border-radius: 5px;
  }
  .selectHeader {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-left: calc(25% + 6px);
    padding-right: 10px;
    white-space: nowrap;
  }
  .selectList {
    width: 100%;
    max-width: 150px;
    position: absolute;
    max-height: 120px;
    overflow-y: auto;
    box-sizing: content-box;
    z-index: 1;
    top: 18px;
    left: -1px;
    padding: 2px 0;
    border-radius: 0px 0px 5px 5px;
    background: #ffffff;
    border: 1px solid #999999;
    border-top: none;
    list-style: none;
    box-shadow: none;

    .selectItem {
      padding: 6px 10px 6px calc(25% + 6px);
      font-weight: 600;
      font-size: 18px;
      line-height: 20px;
    }
    .selectItem:hover {
      background: #ecf5f3;
    }
    .selectItem.selected {
      background: #5991ff;
      color: #ffffff;
    }
  }
  ::-webkit-scrollbar {
    display: none;
  }
`;
